import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Car, Library, Settings } from 'lucide-react';

const BottomNav = ({ activeTab, onTabChange, darkMode = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems = [
    { id: 'home', icon: Home, label: 'Home', path: '/' },
    { id: 'drive', icon: Car, label: 'Drive Mode', path: '/drive-mode' },
    { id: 'library', icon: Library, label: 'Library', path: '/audio-library' },
    { id: 'settings', icon: Settings, label: 'Settings', path: '/settings' },
  ];

  const handleNavClick = (item) => {
    if (onTabChange) {
      onTabChange(item.id);
    }
    if (item.path) {
      navigate(item.path);
    }
  };

  // Determine active tab from location
  const getCurrentTab = () => {
    const currentPath = location.pathname;
    const currentItem = navItems.find(item => item.path === currentPath);
    return currentItem ? currentItem.id : activeTab;
  };

  const currentActiveTab = getCurrentTab();

  return (
    <nav className={`fixed bottom-0 left-0 right-0 border-t z-50 ${
      darkMode ? 'bg-gray-900 border-gray-700' : 'bg-white border-gray-200'
    }`}>
      <div className="grid grid-cols-4 h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentActiveTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => handleNavClick(item)}
              className={`flex flex-col items-center justify-center gap-1 transition-colors ${
                isActive 
                  ? darkMode ? 'text-white' : 'text-gray-900' 
                  : darkMode ? 'text-gray-500' : 'text-gray-400'
              }`}
            >
              <Icon className={`w-6 h-6 ${isActive ? '' : ''}`} strokeWidth={isActive ? 2 : 1.5} />
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
      {/* Safe area padding for bottom navigation gestures */}
      <div className="pb-[env(safe-area-inset-bottom,8px)]" />
    </nav>
  );
};

export default BottomNav;